<template>
    <!-- card-hover-shadow  -->
    <v-container>
        <v-row>
            <v-col cols="12 text-white text-center" >
                <h4 class="text-white mb-5">ประวัติการเล่น</h4>
                <template>
                    <v-card class="bg-black">
                        <v-card class="bg-black" flat>
                            <!-- <v-simple-table dark fixed-header class="tb-fix-height" > -->
                            <v-simple-table dark dense fixed-header :height="heightContent">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">
                                                เลขที่อ้างอิง
                                            </th>
                                            <th class="text-left">
                                                วัน/เวลา
                                            </th>
                                            <th class="text-left">
                                                รายการ & รายละเอียด
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in statmentList" :key="item.name">
                                            <td>{{ item.WT_ID }}</td>
                                            <td>{{ item.CREATE_DATE }}</td>
                                            <td>
                                                <span v-if="item.WHEEL_REQUIRE == 'FAPOINT'">ใช้ {{item.WHEEL_PRICE}} MCPoint ในการหมุนวงล้อ<br></span>
                                                <span v-if="item.WHEEL_REQUIRE == 'card_sillver'">ใช้ {{item.WHEEL_PRICE}} การ์ดเงิน ในการหมุนวงล้อ<br></span>
                                                <span v-if="item.WHEEL_REQUIRE == 'card_gold'">ใช้ {{item.WHEEL_PRICE}} การ์ดทอง ในการหมุนวงล้อ<br></span>
                                                <span v-if="item.RESULT_WR_TYPE == 'credit'">ได้รับ {{item.RESULT_WR_AMT}} เครดิต</span>
                                                <span v-if="item.RESULT_WR_TYPE == 'item'">ได้รับ {{item.RESULT_WR_NAME}} จำนวน {{item.RESULT_WR_AMT}}</span>
                                                <span v-if="item.RESULT_WR_TYPE == 'fapoint'">ได้รับ {{item.RESULT_WR_AMT}} FAPoint</span>
                                                <span v-if="item.RESULT_WR_TYPE == 'empty'">คุณไม่ได้รับรางวัล</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-card>
                </template>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    props: {
    },
    computed: {
        ...mapGetters(['getProducts']),

    },
    data() {
        return {
            tab: null,
            items: [
                'ประวัติ ฝาก-ถอน', 'ประวัติการเล่น'
            ]
            ,statmentList: []
            ,betList: []
            ,heightContent: 0
        }
    },
    async mounted(){
        var resStData = await this.WheelSpinGetWheelHistory();
        if (resStData != false && resStData.Status == 'OK') this.statmentList = resStData.Data;
        this.heightContent = window.innerHeight - 206 + 'px';
    },
    methods: {
        ...mapActions(["WheelSpinGetWheelHistory"]),

    }
}
</script>
<style lang="scss" scoped>
.tb-fix-height {
    height: calc(100vh - 206px) !important;
}
</style>